import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-606ee94a")

_pushScopeId("data-v-606ee94a")
const _hoisted_1 = { class: "payment" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", { class: "txt txt-small" }, "決済金額", -1)
const _hoisted_3 = { class: "txt settlement-amount" }
const _hoisted_4 = { class: "coin-box" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "txt txt-small" }, "購入コイン数:", -1)
const _hoisted_6 = { class: "txt coin-quantity" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "sub-title" }, "カード番号", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { id: "card-number" }, null, -1)
const _hoisted_9 = { class: "sub" }
const _hoisted_10 = { class: "sub-content" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "有効期限", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { id: "card-expiry" }, null, -1)
const _hoisted_13 = { class: "sub-content" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", null, "セキュリティコード", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { id: "card-cvc" }, null, -1)
const _hoisted_16 = { class: "error-message" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Loading = _resolveComponent("Loading")
  const _component_PopUp = _resolveComponent("PopUp")
  const _component_BaseRoundRectButton = _resolveComponent("BaseRoundRectButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Loading, { isActive: _ctx.isLoading }, null, 8, ["isActive"]),
    (_ctx.resultState != 0)
      ? (_openBlock(), _createBlock(_component_PopUp, {
          key: 0,
          text: _ctx.purchaseResultMessage,
          nextFunction: _ctx.closeResultPopUp
        }, null, 8, ["text", "nextFunction"]))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createVNode("p", _hoisted_3, _toDisplayString(_ctx.product.amount.toLocaleString()) + "円", 1),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode("div", _hoisted_6, _toDisplayString((_ctx.product.paid + _ctx.product.earned + _ctx.product.limitedPoint).toLocaleString()) + "コイン", 1)
    ]),
    _createVNode("form", {
      class: "payment-form",
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _hoisted_7,
      _hoisted_8,
      _withDirectives(_createVNode("p", { class: "error-message" }, _toDisplayString(_ctx.state.cardNumberErrorMessage), 513), [
        [_vShow, _ctx.cardNumberError]
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _withDirectives(_createVNode("p", { class: "error-message" }, _toDisplayString(_ctx.state.cardExpiryErrorMessage), 513), [
            [_vShow, _ctx.cardExpiryError]
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _withDirectives(_createVNode("p", { class: "error-message" }, _toDisplayString(_ctx.state.cardCvcErrorMessage), 513), [
            [_vShow, _ctx.cardCvcError]
          ])
        ])
      ]),
      _createVNode("p", _hoisted_16, _toDisplayString(_ctx.error), 1),
      _createVNode(_component_BaseRoundRectButton, {
        class: "btn-main payment-button",
        text: "購入する",
        onClick: _ctx.purchase,
        disable: _ctx.cardError()
      }, null, 8, ["onClick", "disable"])
    ], 32)
  ]))
})